import {createRouter, createWebHistory} from 'vue-router'
import {useAuthStore} from '../stores/authStore'; // Імпорт authStore
import Login from '../views/Login.vue'
import Dashboard from "../views/Dashboard.vue";


const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        redirect: {name: 'Orders'},
        meta: {
            layout: 'default',
            title: 'Dashboard'
        }
    },
    {
        path: '/products',
        name: 'Products',
        component: () => import('../views/products/ProductList.vue'),
        meta: {
            layout: 'default',
            title: 'Список номенклатури'
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        component: () => import('../views/reports/IndexView.vue'),
        meta: {
            layout: 'default',
            title: 'Звіт'
        }
    },
    {
        path: '/orders',
        name: 'Orders',
        component: () => import('../views/orders/OrdersListView.vue'),
        meta: {
            layout: 'default',
            title: 'Замовлення'
        }
    },
    {
        path: '/orders/create/:type_id',
        name: 'CreateOrder',
        component: () => import('../views/orders/CreateOrder.vue'),
        meta: {
            layout: 'default',
            title: 'Створення замовлення',
            breadcrumb: [
                {
                    name: 'Замовлення',
                    to: {name: 'Orders'}
                },
                {
                    name: 'Створення замовлення',
                    to: false
                }
            ]
        }
    },
    {
        path: '/orders/create/:type_id/:order_id',
        name: 'CreateOrderPreOrder',
        component: () => import('../views/orders/CreateOrder.vue'),
        meta: {
            layout: 'default',
            title: 'Створення замовлення',
            breadcrumb: [
                {
                    name: 'Замовлення',
                    to: {name: 'Orders'}
                },
                {
                    name: 'На основі передзамовлення',
                    to: false
                }
            ]
        }
    },
    {
        path: '/orders/:id',
        name: 'OrderDetailView',
        component: () => import('../views/orders/OrderDetailView.vue'),
        meta: {
            layout: 'default',
            title: route => `Замовлення №${route.params.id}`,
            breadcrumb: [
                {
                    name: 'Замовлення',
                    to: {name: 'Orders'}
                },
                {
                    name: route => `Замовлення №${route.params.id}`,
                    to: false
                }
            ]
        }
    },
    {
        path: '/orders/return/:type_id/:order_id',
        name: 'ReturnOrder',
        component: () => import('../views/orders/CreateOrder.vue'),
        meta: {
            layout: 'default',
            title: 'Повернення',
            breadcrumb: [
                {
                    name: 'Замовлення',
                    to: {name: 'Orders'}
                },
                {
                    name: route => `Повернення замовлення №${route.params.order_id}`,
                    to: false
                },
            ]
        }
    },
    {
        path: '/orders/return/:id',
        name: 'ReturnDetailView',
        component: () => import('../views/brand-returns/ReturnDetailView.vue'),
        meta: {
            layout: 'default',
            title: route => `Відправка №${route.params.id}`,
            breadcrumb: [
                {
                    name: 'Відправки бренду',
                    to: {name: 'BrandReturns'}
                },
                {
                    name: route => `Відправка №${route.params.id}`,
                    to: false
                }
            ]
        }
    },
    {
        path: '/brand-returns',
        name: 'BrandReturns',
        component: () => import('../views/brand-returns/ReturnsListView.vue'),
        meta: {
            layout: 'default',
            title: 'Список повернень бренду'
        }
    },
    {
        path: '/brand-returns/create',
        name: 'CreateBrandReturns',
        component: () => import('../views/brand-returns/CreateReturnsView.vue'),
        meta: {
            layout: 'default',
            title: 'Cтворення повернення бренду',
            breadcrumb: [
                {
                    name: 'Список повернень',
                    to: {name: 'BrandReturns'}
                },
                {
                    name: 'Cтворення повернення бренду',
                    to: false
                },
            ]
        }
    },
    {
        path: '/barcode-print',
        name: 'barcode-print',
        component: () => import('../views/BarcodePrint.vue'),
    }

]

const router = createRouter({
    history: createWebHistory(),
    routes
})


router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    document.title = (typeof to.meta.title === 'function'
        ? to.meta.title(to)
        : to.meta.title) || 'BrandRoom';
    if (to.path !== '/login' && !authStore.isAuthenticated) {
        next('/login');
    } else {
        next();
    }
})

export default router
